<template>

  <div id="wrapper" class="">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">

          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li><router-link :to="{name: 'ManageProfiles'}">Manage Profiles</router-link></li>
              <li class="active">
                <span>Profile</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs" v-if="profile">
            Manage Profile - <span class="font-bold">{{profile.name}}</span>
          </h3>
          <small></small>
        </div>
      </div>
    </div>

    <div class="content">

      <div class="row">
        <div class="col-md-6 col-lg-3">
          <div class="hpanel">
            <div class="panel-heading">
              Plans by profile
            </div>
            <div class="panel-body">
              <plans-by-profile v-if="stats" :plans="stats.plans" :height="300"></plans-by-profile>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3">
          <div class="hpanel">
            <div class="panel-heading">
              Role by profile
            </div>
            <div class="panel-body">
              <roles-by-profile v-if="stats && stats.roles" :roles="stats.roles" :height="300"></roles-by-profile>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="hpanel">
            <div class="panel-heading">
              Role by profile
            </div>
            <div class="panel-body">
              <user-activity-by-profile v-if="stats && stats.users" :users="stats.users" :height="300"></user-activity-by-profile>
            </div>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="hpanel">
            <div class="panel-heading">
              Users
            </div>
            <div class="panel-body">
              <div class="table-responsive">
                <table id="userTable" cellpadding="1" cellspacing="1" class="table">
                  <thead>
                  <tr>
                    <th>#</th>
                    <th>LastName</th>
                    <th>FistName</th>
                    <th>Email</th>
                    <th>Plan</th>
                    <th>Role</th>
                    <th>Created at</th>
                    <th>Updated at</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import 'datatables.net-bs/css/dataTables.bootstrap.min.css'
import 'datatables/media/js/jquery.dataTables.min'
import 'datatables.net-bs/js/dataTables.bootstrap.min'
import PlansByProfile from '../../components/charts/PlansByProfile'
import RolesByProfile from '../../components/charts/RolesByProfile'
import UserActivityByProfile from '../../components/charts/UserActivityByProfile'

export default {
  components: {
    UserActivityByProfile,
    PlansByProfile,
    RolesByProfile
  },
  name: 'PreviewProfile',
  props: [],
  data () {
    return {
      profileId: null,
      profile: null,
      users: [],
      stats: null
    }
  },
  methods: {
    errors (status) {
      if (status === 403) {
        this.$router.replace({name: 'Error403', params: {'0': ''}})
      }
      if (status === 404) {
        this.$router.replace({name: 'Error404', params: {'0': ''}})
      }
    },
    getResources () {
      this.axios.get('/profile/' + this.profileId)
        .then((response) => {
          this.profile = response.data
        }).catch((error) => {
          this.errors(error.response.status)
        })

      this.axios.get('/profile/' + this.profileId + '/stats')
        .then((response) => {
          this.stats = response.data
        }).catch((error) => {
          this.errors(error.response.status)
        })
    }
  },
  mounted () {
    let customColumnDefs = []

    customColumnDefs.push({
      targets: 8,
      data: null,
      searchable: false,
      defaultContent: '<router-link  class="btn btn-xs btn-block btn-info btn-outline editUser">' +
          '<i class="fas fa-pencil-alt"></i> Edit </router-link>'
    })

    let dataTable = $('#userTable').DataTable({
      responsive: true,
      processing: true,
      serverSide: true,
      bPaginate: true,
      ajax: {
        url: this.$apiUrl + '/profile/' + this.profileId + '/users?relations={planCredit.plan,roles}',
        error: (xhr, error, thrown) => {
          this.errors(xhr.status)
        },
        dataSrc: 'data',
        beforeSend: function (request) {
          request.setRequestHeader('Authorization', 'Bearer ' + localStorage.default_auth_token
          )
        }
      },
      columns: [
        {data: 'id'},
        {data: 'firstname'},
        {data: 'lastname'},
        {data: 'email'},
        {data: 'plan', name: 'planCredit.plan.name'},
        {data: 'role', searchable: false, orderable: false},
        {data: 'created_at'},
        {data: 'updated_at'}
      ],
      columnDefs: customColumnDefs,
      createdRow: function (row, data, index) {
      },
      buttons: [
        {extend: 'copy', className: 'btn-sm'},
        {extend: 'csv', title: 'ExampleFile', className: 'btn-sm'},
        {extend: 'pdf', title: 'ExampleFile', className: 'btn-sm'},
        {extend: 'print', className: 'btn-sm'}
      ]
    })

    let self = this
    $('#userTable tbody').on('click', '.editUser', function () {
      let data = dataTable.row($(this).parents('tr')).data()
      self.$router.push({name: 'ManageUser', params: {id: data['id']}})
    })
  },
  updated: function () {
    this.$nextTick(function () {
    })
  },
  beforeMount () {
    this.profileId = typeof this.$route.params.id !== 'undefined' ? this.$route.params.id : null
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/manageProfiles/PreviewProfile.vue